import {ListItemProps} from 'component/partial/MetricSection/MetricSection';

import {MetricsSection} from '/constant/TestIDs';
import {BUSINESS_LEADER} from '/enum/competency.enum';
import {
  REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
  REPORT_CLOSE_TO_FIBC_RANK,
  REPORT_CLOSE_TO_SENIOR_COACH_RANK,
} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';

import {CloseToCompetencySectionProps} from './CloseToCompetencySection.types';

export function useCloseToCompetencySection({
  currentUserCompetency = '',
  executiveDirector = 0,
  fibc = 0,
  seniorCoach = 0,
  onShowInfoPopover = () => {},
  onShowReport = () => {},
}: CloseToCompetencySectionProps) {
  const {tt, ts} = useTranslation(
    'screen.teams.section.closeToCompetencySection',
  );
  const listItems: ListItemProps[] = [
    {
      label: tt('seniorCoach', 'Close to Senior Coach'),
      value: seniorCoach,
      recordsName: REPORT_CLOSE_TO_SENIOR_COACH_RANK,
      testID: MetricsSection.metricCloseToSeniorCoach,
    },
    {
      label: tt('executiveDirector', 'Close to Executive Director'),
      value: executiveDirector,
      recordsName: REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
      testID: MetricsSection.metricCloseToExecutiveDirector,
    },
  ];

  if (currentUserCompetency === BUSINESS_LEADER) {
    listItems.push({
      label: tt('fibc', 'Close to FIBC'),
      value: fibc,
      recordsName: REPORT_CLOSE_TO_FIBC_RANK,
      testID: MetricsSection.metricCloseFIBC,
    });
  }

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Close to Competency'),
      body: tt(
        'info.body',
        'These Coaches are nearing important milestones – Senior Coach, Executive Director, or FIBC. Why not reach out and see what they might need to get there?',
      ),
    });

  const onItemPress = ({recordsName, value}: any) =>
    onShowReport({recordsName, loadingData: {total: value}});

  return {listItems, onInfoPress, onItemPress, tt, ts};
}
